// "An inner control wants this Escape" — the arbiter between a dialog and a
// popover open on top of it. Split out of Modal.jsx for the same
// react-refresh reason as useConfirm.js / timeAgo.js / csvParse.js: a
// component file should export only components.
//
// Why it needs to exist at all: Modal.jsx's Escape listener is on `document`
// in the CAPTURE phase and stops propagation, which is what keeps a stack of
// dialogs from all closing at once — but capture at `document` runs before
// the event reaches anything else, React's own delegated `onKeyDown`
// included. So a nested control that closes itself on Escape (a date picker,
// a reference-field dropdown, an @-mention autocomplete) never saw the key
// at all once it was inside a dialog: Escape blew away the whole form
// instead of dismissing the popover on top of it, taking whatever had been
// typed with it. Three of those four call sites predate the overlay
// conversion — they were already broken inside `live/RecordForm.jsx`.
//
// A claim is a FLAG, not a handler: it means "stand down, something inner
// will deal with this one". Modal then returns without stopping propagation,
// so the claiming control's own existing listener fires exactly as it does
// outside a dialog. That's deliberately the whole contract — a control keeps
// ONE Escape implementation for both contexts instead of growing a second
// one for the in-a-modal case, which is the version that rots.
//
// Claim while the inner thing is open, release when it closes:
//   useEffect(() => (open ? claimEscape() : undefined), [open]);
const escapeClaims = [];

export function claimEscape() {
  const token = {};
  escapeClaims.push(token);
  return () => {
    const i = escapeClaims.indexOf(token);
    if (i !== -1) escapeClaims.splice(i, 1);
  };
}

export function escapeIsClaimed() {
  return escapeClaims.length > 0;
}
